import ReactCodeInput from "react-code-input";

export function InputCode({ length = 6, setCode = () => {}, ...props }) {
  return (
    <div className="flex gap-3">
      <ReactCodeInput
        type="number"
        fields={length}
        onChange={setCode}
        className="text-black !flex gap-2 cera-medium-font"
        inputStyle={{
          width: "40px",
          borderRadius: "0px",
          MozAppearance: "textfield",
          fontSize: "16px",
          height: "35px",
          color: "#5A3615",
          border: "none",
          borderBottom: "1px solid #5A3615",
        }}
        {...props}
      />
    </div>
  );
}
